export const lunchroom = {
  seo: {
    title: 'Case: Two-B Lunchroom | Bistroo',
    description: 'Wie Two-B, die leckersten Brötchen der Region, dank Bistroo online wuchs.',
  },
  hero: {
    title: 'Two-B "die leckersten Brötchen der Region" wächst online durch Bistroo',
    description:
      'Two B by Mondie ist eine bekannte Adresse in Veldhoven und Umgebung und hat kürzlich auch eine neue Filiale in Helmond & Best eröffnet. Sie bedienen die gesamte Region mit köstlichen Brötchen.',
  },
  testimonials: {
    1: {
      text: '"Bistroo spart uns täglich viel Zeit und reduziert die Frustration bei unseren Kunden erheblich."',
      name: 'Mondie Scheepers',
      job_title: 'Business Owner',
    },
    2: {
      text: '"Das Menü ist einfach anzupassen und bietet Kunden einen klaren Überblick."',
      name: 'Mondie Scheepers',
      job_title: 'Business Owner',
    },
  },
  challenge: {
    paragraph: {
      title: 'Innovation braucht Zeit',
      text: 'Früher waren telefonische Bestellungen und Abholung an der Theke die wichtigsten Wege, Kunden zu bedienen, was zu langen Warteschlangen und Ineffizienzen in Stoßzeiten führte. Der Inhaber, Lars, arbeitet seit mehr als 2 Jahren mit Bistroo zusammen und teilt gerne einige Herausforderungen, die sie vor der Zusammenarbeit hatten, sowie die Lösungen, die Bistroo bietet.',
    },
    paragraph_2: {
      title: 'Die Herausforderung',
      bullets: {
        1: 'Two B By Mondie hatte häufig mit Andrang in der Mittagszeit zu kämpfen, was zu langen Warteschlangen und weniger zufriedenen Kunden führte.',
        2: 'Bestellungen per Telefon verursachten Verzögerungen und Verwirrung, besonders in Stoßzeiten.',
        3: 'Durch menschliche Fehler und Missverständnisse bei telefonischen Bestellungen kamen Bestellungen manchmal falsch an, was zu unzufriedenen Kunden und verschwendeter Zeit führte.',
        4: 'Kunden wollten immer öfter online bestellen wegen der Bequemlichkeit und erwarteten ein nahtloses Abholerlebnis ohne lange Wartezeiten.',
      },
    },
  },
  solution: {
    title: 'Die Lösung',
    checklist: {
      1: 'Dank Bistroo konnten Kunden ihre Bestellungen im Voraus aufgeben, wodurch Two B By Mondie in Stoßzeiten effizienter arbeiten konnte und Kunden direkt ohne Warten abholen konnten.',
      2: "Mit Bistroos Online-Bestelllösung hatte Two B By Mondie einen klaren Überblick über Bestellungen, wodurch Fehler reduziert und die Küche effizienter arbeiten konnte.",
      3: 'Mit Bistroo konnte Two B By Mondie seine eigenen Stoßzeiten verwalten, wodurch das Kundenerlebnis verbessert und der Umsatz maximiert werden konnte.',
      4: 'Alle Bestellungen über Bistroo wurden im Voraus bezahlt, was das Risiko nicht abgeholter Bestellungen verringerte und eine reibungslosere Abwicklung an der Theke gewährleistete.',
    },
  },
  conclusion: {
    title: 'Das Fazit',
    text: {
      1: 'Bistroos Online-Bestelllösung bot Two B By Mondie nicht nur eine effektive Möglichkeit, diese Herausforderungen zu bewältigen, sondern transformierte auch ihren Geschäftsbetrieb. "Seit wir mit Bistroo zusammenarbeiten, können unsere Kunden ihre Bestellungen einfach online aufgeben. Das spart uns täglich viel Zeit und reduziert die Frustration bei unseren Kunden erheblich", so Lars. Er schätzt auch die Benutzerfreundlichkeit des Menüanpassungssystems und den ausgezeichneten Kundenservice von Bistroo: "Wenn wir Fragen haben, erhalten wir schnell und kompetent Hilfe."',
      2: "Außerdem bietet Bistroo stets eine 30-tägige Testphase an, in der Kunden den Service kostenlos nutzen können. In fast allen Fällen besteht eine gegenseitige Absicht, die Nutzung von Bistroos Online-Bestelllösung fortzusetzen, was den Wert und die Effektivität der Bestellsoftware für Lunchrooms wie Two B By Mondie bezeugt.",
    },
  },
}
